// extracted by mini-css-extract-plugin
export var compactFilters = "_f1-4";
export var detailImage = "_f1-1";
export var dropdownContainer = "_f1-2";
export var imageContainer = "_f1-0";
export var selectedCard = "_f1-3";